import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';
import styles from './Heart.module.scss';

export type HeartProps = { active?: boolean } & IconProps;
export const Heart = ({ active = false }: HeartProps) => (
  <Icon
    className={classNames(styles.root, { [styles.active]: active })}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.93062 2.9389C4.0462 0.925009 7.47586 0.925009 9.5907 2.9389L10.0007 3.32937L10.41 2.93958C12.5256 0.925693 15.9553 0.925693 18.0694 2.93958L18.4133 3.26646C20.5289 5.28035 20.5289 8.54634 18.4133 10.5602L18.0048 10.95L10.5758 18.0231C10.2533 18.3301 9.74666 18.3301 9.42419 18.0231L1.99673 10.9507L1.58669 10.5602C-0.528896 8.54634 -0.528896 5.28035 1.58669 3.26646L1.93062 2.9389Z"
      fill="currentColor"
    />
  </Icon>
);
